import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-locize-backend";

const env = (import.meta as any).env;
const dev = !env.MODE || !!env.DEV;

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: dev,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    ns: "translations",
    saveMissing: dev,
    updateMissing: false,
    missingKeyNoValueFallbackToKey: true,
    backend: {
      projectId: env.VITE_LOCIZE_PROJECT_ID,
      apiKey: env.VITE_LOCIZE_API_KEY,
      referenceLng: env.VITE_LOCIZE_REFERENCE_LNG,
      version: env.VITE_LOCIZE_VERSION,
      cdnType: "pro",
    },
  });

export default i18n;
